export type GranularityItem = {
  value: string;
  amount: number;
};

export const GRANULARITY: { [key: string]: GranularityItem } = {
  MINUTES: {
    value: 'Minutes',
    amount: 1,
  },
  HOURS: {
    value: 'Hours',
    amount: 60,
  },
  DAYS: {
    value: 'Days',
    amount: 1440,
  },
  WEEKS: {
    value: 'Weeks',
    amount: 10080,
  },
  MONTHS: {
    value: 'Months',
    amount: 43200,
  },
};

export const granularityValues = Object.values(GRANULARITY);

export const intervalToGranularity = (interval: number) => {
  const selectedKey =
    Object.keys(GRANULARITY)
      .reverse()
      .find(key => interval % GRANULARITY[key].amount === 0) || 'HOURS';
  return {
    granularity: GRANULARITY[selectedKey],
    counter: interval / GRANULARITY[selectedKey].amount,
  };
};
